<template>
  <div>
    <div class="w-100 rounded border-form d-flex align-items-center overflow-hidden">
      <span class="body-2-4 bg-light-desktop border-r-form p-2">
        {{ getCurrency.symbol_native }}
      </span>
      <input
        class="text-14 font-lato border-0 px-2 no-focus-border"
        type="text"
        ref="abc"
        v-model="reacting_value"
        :disabled="disabled"
        @focus="selectAll()"
        @input="reactingFormater()"
        @keydown="keyDownHandler"
        @blur="onBlurHandler()"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  props: {
    value: {
      default: "0",
    },
    digit_currency: {
      type: Number,
      default: 0,
    },
    custom_currency: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    allow_negative: {
      type: Boolean,
      default: false,
    },
    isCallBackOnBlur: {
      type: Boolean,
      default: false,
    },
    isCallBackOnKeyDown: {
      type: Boolean,
      default: false,
    },
    keyWatch: {
      type: String,
      default: "",
    },
    callBackData: {
      type: [Array, String, Boolean, Number, Object],
      default: "",
    },
    mode: {
      type: String,
      default: "currency",
    },
  },
  data() {
    return {
      isInputActive: false,
      original_value: 0,
      reacting_value: "0",
      last_length_input: 0,
      last_comma_count: 0,
    };
  },
  computed: {
    ...mapGetters(["getCurrency"]),
  },
  mounted() {
    this.original_value = Number(this.value);
    this.reacting_value = Number(this.value);
    this.last_length_input = Number(this.value).length - 1;
    this.firstFormatPrice();
  },
  methods: {
    reactingFormater() {
      let num_for_reactor = this.reacting_value;
      let cursor_reset_to1 = false;
      if (this.countSeparator(num_for_reactor) > 1) {
        let pos_last_separator = num_for_reactor.lastIndexOf(".");
        num_for_reactor = num_for_reactor.substring(0, pos_last_separator);
      }

      let use_formater_number = true;
      let full_disable_formater_number = false;
      if (num_for_reactor.substring(0, 1) == "0") {
        use_formater_number = false;
      } else if (num_for_reactor.substring(0, 1) == ",") {
        use_formater_number = false;
        num_for_reactor = num_for_reactor.substring(1, num_for_reactor.length);
      }

      let pos_check_zero = num_for_reactor.indexOf("0.00");
      if (pos_check_zero == 0) {
        num_for_reactor = num_for_reactor.substring(
          pos_check_zero + 4,
          num_for_reactor.length
        );
        cursor_reset_to1 = true;
      }

      if (
        this.allow_negative == true &&
        num_for_reactor.length == 1 &&
        num_for_reactor.substring(0, 1) == "-"
      ) {
        full_disable_formater_number = true;
        use_formater_number = false;
        cursor_reset_to1 = true;
      }

      let pos_last_negative = num_for_reactor.lastIndexOf("-");
      if (pos_last_negative > 0) {
        num_for_reactor = num_for_reactor.substring(
          pos_last_negative,
          num_for_reactor.length
        );
        cursor_reset_to1 = true;
      }

      let before_update_position_marker = this.$refs.abc.selectionEnd;

      let number_value = Number(0);
      if (full_disable_formater_number == false) {
        if (this.allow_negative == true) {
          number_value = Number(num_for_reactor.replace(/[^-?\d\.]/g, ""));
        } else {
          number_value = Number(num_for_reactor.replace(/[^\d\.]/g, ""));
        }
      } else {
        number_value = num_for_reactor;
      }

      // sendback to modal on parent
      this.$emit("input", number_value);
      // set original value
      this.original_value = number_value;

      if (use_formater_number == true) {
        if (this.allow_negative == true) {
          this.reacting_value = number_value
            .toFixed(this.getCurrency.digit)
            .replace(/(-?\d)(?=(-?\d{3})+(?:\.\d+)?$)/g, "$1,");
        } else {
          this.reacting_value = number_value
            .toFixed(this.getCurrency.digit)
            .replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,");
        }
      } else {
        if (full_disable_formater_number == false) {
          let first_dot_position = num_for_reactor.indexOf(".");
          num_for_reactor = num_for_reactor.substring(
            0,
            first_dot_position + 3
          );

          if (this.allow_negative == true) {
            this.reacting_value = num_for_reactor.replace(/[^-?\d\.]/g, "");
          } else {
            this.reacting_value = num_for_reactor.replace(/[^\d\.]/g, "");
          }
        } else {
          this.reacting_value = num_for_reactor;
        }
      }

      let new_comma_count = this.countComma(this.reacting_value);

      let new_position_marker = 0;
      let new_length_input = this.$refs.abc.value.length;
      if (before_update_position_marker <= new_length_input) {
        new_position_marker = before_update_position_marker;
        if (new_comma_count < this.last_comma_count) {
          new_position_marker--;
        } else if (new_comma_count > this.last_comma_count) {
          new_position_marker++;
        }
      }

      if (cursor_reset_to1 == true) {
        new_position_marker = 1;
      }

      this.$nextTick(() => {
        this.$refs.abc.selectionStart = new_position_marker;
        this.$refs.abc.selectionEnd = new_position_marker;
      });

      this.last_length_input = this.$refs.abc.value.length;
      this.last_comma_count = this.countComma(this.reacting_value);

      this.$emit("v-change");
    },
    firstFormatPrice() {
      let num_for_reactor = String(this.reacting_value);
      if (isNaN(num_for_reactor)) {
        num_for_reactor = "0";
      }

      let number_value = Number(0);
      if (this.allow_negative == true) {
        number_value = Number(num_for_reactor.replace(/[^-?\d\.]/g, ""));
      } else {
        number_value = Number(num_for_reactor.replace(/[^\d\.]/g, ""));
      }
      this.original_value = number_value;

      if (this.allow_negative == true) {
        this.reacting_value = number_value
          .toFixed(this.getCurrency.digit)
          .replace(/(-?\d)(?=(-?\d{3})+(?:\.\d+)?$)/g, "$1,");
      } else {
        this.reacting_value = number_value
          .toFixed(this.getCurrency.digit)
          .replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,");
      }
    },
    countComma(string) {
      return string.split(",").length - 1;
    },
    countSeparator(string) {
      return string.split(".").length - 1;
    },
    selectAll() {
      this.$refs.abc.setSelectionRange(0, this.$refs.abc.value.length);
    },
    onBlurHandler() {
      this.$emit("onback-blur");
      this.reformatPriceOnBlur();
      // if(this.isCallBackOnBlur==true){
      // }
    },
    reformatPriceOnBlur() {
      let num_for_reactor = this.reacting_value;
      let number_value = Number(0);
      if (this.allow_negative == true) {
        if (
          num_for_reactor.length == 1 &&
          num_for_reactor.substring(0, 1) == "-"
        ) {
          num_for_reactor = "0";
        }

        number_value = Number(num_for_reactor.replace(/[^-?\d\.]/g, ""));
      } else {
        number_value = Number(num_for_reactor.replace(/[^\d\.]/g, ""));
      }
      // sendback to modal on parent
      this.$emit("input", number_value);
      // set original value
      this.original_value = number_value;

      if (this.allow_negative == true) {
        this.reacting_value = number_value
          .toFixed(this.getCurrency.digit)
          .replace(/(-?\d)(?=(-?\d{3})+(?:\.\d+)?$)/g, "$1,");
      } else {
        this.reacting_value = number_value
          .toFixed(this.getCurrency.digit)
          .replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,");
      }
    },
    keyDownHandler(data) {
      if (this.isCallBackOnKeyDown == true && data.key == this.keyWatch) {
        this.$emit("onback-keydown", this.callBackData);
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/general/inputCurrencyV2.vue